import useGetColors from "../../utils/colors";

export const useGetNewPasswordStyles = () => {
  const { themeColors } = useGetColors();

  return {
    container: {
      width: "70%",
      maxWidth: 300,
      margin: "0 auto",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      paddingTop: 80,
      gap: 70,
    },
    heading: {
      margin: 0,
      textAlign: "left",
      color: themeColors.white,
    },
    formContainer: {},
    buttonContainer: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%",
    },
  };
};
